// src/lib/useEventLogger.ts
"use client";

import { useCallback, useRef } from "react";
import { v4 as uuidv4 } from "uuid";

type LogFn = (event: string, props?: Record<string, any>) => void;

export function useEventLogger(): { log: LogFn } {
  const lastRef = useRef<{ key: string; at: number } | null>(null);

  const log = useCallback<LogFn>((event, props = {}) => {
    try {
      const ev = String(event || "").trim();
      if (!ev) return;

      // 連打ガード（同一キー 500ms は捨てる）
      const key = `${ev}:${JSON.stringify(props ?? {}).slice(0, 200)}`;
      const now = Date.now();
      if (lastRef.current && lastRef.current.key === key && now - lastRef.current.at < 500) return;
      lastRef.current = { key, at: now };

      const payload = {
        event: ev,
        eventId: uuidv4(),
        props,
        page: typeof window !== "undefined" ? window.location.pathname : "",
      };

      const url = "/api/events";

      if (typeof navigator !== "undefined" && "sendBeacon" in navigator) {
        const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
        (navigator as any).sendBeacon(url, blob);
        return;
      }

      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(() => {});
    } catch {
      // ログはUIを絶対に壊さない
    }
  }, []);

  return { log };
}
